module.exports = __webpack_public_path__ + "img/image2.de8b44db.png";